import dotProp from 'dot-prop-immutable'
import {
  COPY_FRAME,
  DESELECT_FRAME,
  INSERT_FRAME,
  REMOVE_FRAME,
  REMOVE_SET,
  ROTATE_FRAME,
  SELECT_FRAME, UPDATE_WALLPAPER, UPDATE_WALLPAPER_DIM
} from "../../constants/projectActions";
import calcCenter from '../../utils/calcCenter'
import { disallowToResize } from './resizable'
import { currentSize } from '../frames'

export const insertFrame = (width, height) => dispatch => {
  const { x, y } = getCalcCenter(width, height)

  dispatch({ type: INSERT_FRAME, width, height, positionX: x, positionY: y })
  dispatch(disallowToResize())
}

export const removeFrame = () => (dispatch, ownState) => {
  const isSetOrFrame = dotProp.get(ownState(), `project.selectedObject`, '')
  const action = isSetOrFrame === 'frame' ? REMOVE_FRAME : REMOVE_SET

  dispatch({ type: action, index: dotProp.get(ownState(), 'project.selectedIndex') })
  dispatch(disallowToResize())
}

export const copyFrame = () => (dispatch, ownState) => {
  dispatch(disallowToResize())
  dispatch({ type: COPY_FRAME, index: dotProp.get(ownState(), 'project.selectedIndex') })
  dispatch({ type: SELECT_FRAME, index: dotProp.get(ownState(), 'project.pictures', []).length - 1 })
}

export const rotateFrame = () => (dispatch, ownState) => {
  dispatch(disallowToResize())
  dispatch({ type: ROTATE_FRAME, index: dotProp.get(ownState(), 'project.selectedIndex') })
}

export const selectFrame = index => (dispatch, ownState) => {
  const product = dotProp.get(ownState(), `project.pictures.${index}`, { width: 0, height: 0 })

  dispatch(disallowToResize())
  dispatch(currentSize({ width: product.width, height: product.height }))
  dispatch({ type: SELECT_FRAME, index })
}

export const deselectFrame = () => dispatch => {
  dispatch(disallowToResize())
  dispatch(currentSize({ width: 0, height: 0 }))
  dispatch({ type: DESELECT_FRAME })
}

export const updateWallpaperAspect = (a) => dispatch => {
  dispatch({type: UPDATE_WALLPAPER, a})
}

export const updateWallpaperDim = (w, h) => dispatch => {
  dispatch({type: UPDATE_WALLPAPER_DIM, w, h})
}


function getCalcCenter(width, height) {
  return calcCenter(
    {
      width: document.getElementById('wall-app').offsetWidth,
      height: document.getElementById('wall-app').offsetHeight,
    },
    { width, height }
  )
}



// WEBPACK FOOTER //
// ./src/actions/project/frame.js